"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ajv_1 = __importDefault(require("ajv"));
var localeSchema = {
    $id: '/APILocale',
    type: 'string',
    enum: ['de-DE', 'de-AT', 'de-CH', 'fr-CH'],
};
/** settings represent the props that are required for each GraphQL request */
exports.schema = {
    alternativeProducts: {
        type: 'object',
        properties: {
            id: { type: 'string', minLength: 1 },
            locale: { $ref: '/APILocale' },
        },
        required: ['id', 'locale'],
        additionalProperties: true,
    },
    criteoProducts: {
        type: 'object',
        properties: {
            item: { type: 'string', minLength: 1 },
            locale: { $ref: '/APILocale' },
            price: { type: 'number', minimum: 0.0 },
            available: { type: 'number' },
            sid: { type: 'string' },
            uid: { type: 'string' },
        },
        required: ['item', 'locale', 'price', 'available'],
    },
    lastSeenProducts: {
        type: 'object',
        properties: {
            locale: { $ref: '/APILocale' },
            sid: { type: 'string' },
            uid: { type: 'string' },
        },
        required: ['locale'],
    },
    outfit: {},
    complementaryProducts: {
        type: 'object',
        properties: {
            locale: { $ref: '/APILocale' },
            pid: { type: 'string' },
        },
        required: ['locale', 'pid'],
    },
    similarProducts: {
        type: 'object',
        properties: {
            locale: { $ref: '/APILocale' },
            pid: { type: 'string' },
        },
        required: ['locale', 'pid'],
    },
    prudSysAddToBasket: {
        type: 'object',
        properties: {
            pid: { type: 'string', minLength: 1 },
            sid: { type: 'string' },
            brand: { type: 'string' },
            locale: { $ref: '/APILocale' },
            uid: { type: 'string' },
            cid: { type: 'string', minLength: 1 },
            cid0: { type: 'string' },
            cid1: { type: 'string' },
            cid2: { type: 'string' },
            cid3: { type: 'string' },
            tracking: { type: 'boolean' },
        },
        required: ['pid', 'brand', 'locale', 'cid'],
    },
    prudsysCategoryToBrands: {
        type: 'object',
        properties: {
            cid: { type: 'string', minLength: 1 },
            sid: { type: 'string' },
            uid: { type: 'string' },
            locale: { $ref: '/APILocale' },
        },
        required: ['cid', 'locale'],
    },
    prudsysCategoryToBrandsPapi: {
        type: 'object',
        properties: {
            cid: { type: 'string' },
            sid: { type: 'string' },
            uid: { type: 'string' },
            locale: { $ref: '/APILocale' },
            papibrands: {
                type: 'array',
                items: {
                    type: 'string',
                    minLength: 1,
                },
            },
        },
        required: ['cid', 'locale', 'papibrands'],
    },
    prudsysCategoryToCategories: {
        type: 'object',
        properties: {
            cid: { type: 'string' },
            locale: { $ref: '/APILocale' },
            tracking: { type: 'boolean' },
        },
        required: ['cid', 'locale'],
    },
    prudsysCategoryToCategoriesPapi: {},
    prudsysCategoryToProducts: {
        type: 'object',
        properties: {
            locale: { $ref: '/APILocale' },
            cid: { type: 'string', minLength: 1 },
            sid: { type: 'string' },
            tracking: { type: 'boolean' },
        },
        required: ['locale', 'cid'],
    },
    prudsysCategoryToProductsPapi: {
        type: 'object',
        properties: {
            locale: { $ref: '/APILocale' },
            cid: { type: 'string', minLength: 1 },
            sid: { type: 'string' },
            papiproducts: { type: 'array', items: { type: 'string', minLength: 1 } },
            tracking: { type: 'boolean' },
        },
        required: ['locale', 'cid', 'papiproducts'],
    },
    prudsysHomePage: {
        type: 'object',
        properties: {
            pid: { type: 'string' },
            sid: { type: 'string' },
            uid: { type: 'string' },
            locale: { $ref: '/APILocale' },
            cid: { type: 'string' },
            brand: { type: 'string' },
            tracking: { type: 'boolean' },
        },
        required: ['locale'],
    },
    prudSysProducts: {
        type: 'object',
        properties: {
            pid: { type: 'string', minLength: 1 },
            sid: { type: 'string' },
            brand: { type: 'string' },
            locale: { $ref: '/APILocale' },
            cid: { type: 'string', minLength: 1 },
            cid0: { type: 'string' },
            cid1: { type: 'string' },
            cid2: { type: 'string' },
            cid3: { type: 'string' },
            tracking: { type: 'boolean' },
        },
        required: ['pid', 'brand', 'locale', 'cid'],
    },
    prudSysProductsSimilar: {
        type: 'object',
        properties: {
            pid: { type: 'string', minLength: 1 },
            sid: { type: 'string' },
            brand: { type: 'string' },
            locale: { $ref: '/APILocale' },
            cid: { type: 'string', minLength: 1 },
            cid0: { type: 'string' },
            cid1: { type: 'string' },
            cid2: { type: 'string' },
            cid3: { type: 'string' },
            tracking: { type: 'boolean' },
        },
        required: ['pid', 'brand', 'locale', 'cid'],
    },
    prudSysSearchTerm: {
        type: 'object',
        properties: {
            term: { type: 'string', minLength: 1 },
            sid: { type: 'string' },
            uid: { type: 'string' },
            locale: { $ref: '/APILocale' },
            tracking: { type: 'boolean' },
        },
        required: ['term', 'locale'],
    },
    prudsysUserToProductsPapi: {
        type: 'object',
        properties: {
            locale: { $ref: '/APILocale' },
            papiproducts: { type: 'array', items: { type: 'string', minLength: 1 } },
            pid: { type: 'string' },
            uid: { type: 'string' },
            cid: { type: 'string' },
            brand: { type: 'string' },
            tracking: { type: 'boolean' },
        },
        required: ['locale', 'papiproducts'],
    },
    seriesProducts: {
        type: 'object',
        properties: {
            id: { type: 'string' },
            locale: { $ref: '/APILocale' },
        },
        required: ['locale'],
    },
};
var checkSufficientQueryParams = function (queryName, queryParams) {
    var _a;
    var ajv = new ajv_1.default({ allErrors: true });
    var validate = ajv.addSchema(localeSchema).compile(exports.schema[queryName]);
    var valid = validate(queryParams);
    if (!valid) {
        (_a = validate.errors) === null || _a === void 0 ? void 0 : _a.forEach(function (error) {
            /* eslint-disable no-console */
            console.error(error);
            console.error(error.schemaPath + ": " + error.message);
            /* eslint-enable no-console */
        });
    }
    return valid;
};
exports.default = checkSufficientQueryParams;
//# sourceMappingURL=checkSufficientQueryParams.js.map